<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">セット企画検索</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">プロモーション名称</label>
              <div class="list-input-content">
                <app-text-input id="txt_PromotionName" #txt_PromotionName [subid]="'txt_PromotionName'" style="width:21rem;"
                  [(ngModel)]="kymw1313Model.promotionName" [restrict]="'[ -￮]'" [maxChars]="20" [fullOnly]="true"
                  [displayCountField]="false" [forcedEnabledMode]="'true'" [tabindex]="0"></app-text-input>
              </div>
              
              <label class="list-input-title">Ｐコード</label>
              <div class="list-input-content">
                <input type="text" id="txt_PCode" [(ngModel)]="kymw1313Model.pCode" class="pcode"
                  forcedEnabledMode="true" plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8" [tabindex]="0">
              </div>

              <label class="list-input-title">会員生協</label>
              <div class="list-input-content">
                <app-coop-code-combo-box id="cmb_Coop" [subid]="'cmb_Coop'"
                  [(ngModel)]="kymw1313Model.coop" [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-coop-code-combo-box>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title" [style.visibility]="'hidden'">ダミー（表示位置調整用）</label>
              <div class="list-input-content"></div>

              <label class="list-input-title">セット企画商品名</label>
              <div class="list-input-content">
                <app-text-input id="txt_SetDelivGoodsName" [subid]="'txt_SetDelivGoodsName'" style="width:21rem;"
                  [(ngModel)]="kymw1313Model.setDelivGoodsName" [restrict]="'[ -￮]'" [maxChars]="20" [fullOnly]="true"
                  [forcedEnabledMode]="'true'" [displayCountField]="false" [tabindex]="0">
                </app-text-input>
              </div>

              <label class="list-input-title">部門コード</label>
              <div class="list-input-content">
                <app-class-code-combo-box id="cmb_ClassCode" class="list-input-content" [subid]="'cmb_ClassCode'"
                  [(ngModel)]="kymw1313Model.classCode" [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-class-code-combo-box>
              </div>
            </div>
          </div>
          <button id="btn_Search" class="btn-secondary" #btn_Search forcedEnabledMode="true"
            (click)="eventSearch_CLICKHandler(null)" [tabindex]="0">検索
          </button>
        </div>

        <wj-flex-grid [style.width.px]="1378" [style.height.px]="512" id="dtg_PromotionGoods" #dtg_PromotionGoods
          [itemsSource]="kymw1313Model.promotionInfo" forcedEnabledMode="true" [isReadOnly]="true"
          [headersVisibility]="'Column'" [allowDragging]="'None'" [tabindex]="-1">

          <wj-flex-grid-column [minWidth]="5" [header]="'プロモーションＮＯ'" [width]="135" [binding]="'promotionNo'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'プロモーション名称'" [width]="155"
            [binding]="'promotionName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="95" [binding]="'pCode'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="160"
            [binding]="'guideGoodsName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="190"
            [binding]="'guideStandardName'"></wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="160" [header]="'セット企画\n商品名'" id="col_SetDelivGoodsName"
            [binding]="'setDelivGoodsName'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="160" [header]="'セット企画\n商品名（カナ）'" id="col_SetDelivGoodsNameKana"
            [binding]="'setDelivGoodsNameKana'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="105" [header]="'セット企画\n規格名\n'" id="col_SetDelivStandardName"
            [binding]="'setDelivStandardName'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="115" [header]="'セット企画\n規格名（カナ）'"
            id="col_SetDelivStandardNameKana" [binding]="'setDelivStandardNameKana'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [header]="'セット企画\n\n区分'" [binding]="'setPlanDivName'" [width]="75"
            id="cmb_SetPlanDiv" resizable="true" [multiLine]="true">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'単品注文\n\n可否区分'" [binding]="'singleOrderFlagName'" [width]="80"
            id="cb_SingleOrderFlag" resizable="true" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceIB" [binding]="'thisTimeSupplyPriceIB'"
            [header]="'供給価格\nいばらき'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceIB">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceIB"
            [binding]="'thisTimeCostPriceIB'" [header]="'仕入価格\nいばらき'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceIB">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumIB" [binding]="'approvedNumIB'"
            [header]="'セット企画数量\nいばらき'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumIB">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceIB" [binding]="'approvedPriceIB'"
            [header]="'成立価格\nいばらき'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceIB">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeIB"
            [binding]="'deliveryLeadTimeTypeNameIB'" [header]="'配達リード区分\nいばらき'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceTO" [binding]="'thisTimeSupplyPriceTO'"
            [header]="'供給価格\nとちぎ'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTO">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceTO"
            [binding]="'thisTimeCostPriceTO'" [header]="'仕入価格\nとちぎ'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTO">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumTO" [binding]="'approvedNumTO'"
            [header]="'セット企画数量\nとちぎ'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumTO">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceTO" [binding]="'approvedPriceTO'"
            [header]="'成立価格\nとちぎ'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTO">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeTO"
            [binding]="'deliveryLeadTimeTypeNameTO'" [header]="'配達リード区分\nとちぎ'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceGU" [binding]="'thisTimeSupplyPriceGU'"
            [header]="'供給価格\nぐんま'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceGU">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceGU"
            [binding]="'thisTimeCostPriceGU'" [header]="'仕入価格\nぐんま'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceGU">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumGU" [binding]="'approvedNumGU'"
            [header]="'セット企画数量\nぐんま'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumGU">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceGU" [binding]="'approvedPriceGU'"
            [header]="'成立価格\nぐんま'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceGU">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeGU"
            [binding]="'deliveryLeadTimeTypeNameGU'" [header]="'配達リード区分\nぐんま'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceTI" [binding]="'thisTimeSupplyPriceTI'"
            [header]="'供給価格\nちば'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTI">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceTI"
            [binding]="'thisTimeCostPriceTI'" [header]="'仕入価格\nちば'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTI">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumTI" [binding]="'approvedNumTI'"
            [header]="'セット企画数量\nちば'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumTI">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceTI" [binding]="'approvedPriceTI'"
            [header]="'成立価格\nちば'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTI">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeTI"
            [binding]="'deliveryLeadTimeTypeNameTI'" [header]="'配達リード区分\nちば'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceSA" [binding]="'thisTimeSupplyPriceSA'"
            [header]="'供給価格\nさいたま'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceSA">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceSA"
            [binding]="'thisTimeCostPriceSA'" [header]="'仕入価格\nさいたま'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceSA">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumSA" [binding]="'approvedNumSA'"
            [header]="'セット企画数量\nさいたま'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumSA">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceSA" [binding]="'approvedPriceSA'"
            [header]="'成立価格\nさいたま'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceSA">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeSA"
            [binding]="'deliveryLeadTimeTypeNameSA'" [header]="'配達リード区分\nさいたま'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceTK" [binding]="'thisTimeSupplyPriceTK'"
            [header]="'供給価格\nとうきょう'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTK">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceTK"
            [binding]="'thisTimeCostPriceTK'" [header]="'仕入価格\nとうきょう'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTK">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumTK" [binding]="'approvedNumTK'"
            [header]="'セット企画数量\nとうきょう'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumTK">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceTK" [binding]="'approvedPriceTK'"
            [header]="'成立価格\nとうきょう'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTK">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeTK"
            [binding]="'deliveryLeadTimeTypeNameTK'" [header]="'配達リード区分\nとうきょう'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceNA" [binding]="'thisTimeSupplyPriceNA'"
            [header]="'供給価格\nながの'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceNA">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceNA"
            [binding]="'thisTimeCostPriceNA'" [header]="'仕入価格\nながの'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceNA">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumNA" [binding]="'approvedNumNA'"
            [header]="'セット企画数量\nながの'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumNA">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceNA" [binding]="'approvedPriceNA'"
            [header]="'成立価格\nながの'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceNA">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeNA"
            [binding]="'deliveryLeadTimeTypeNameNA'" [header]="'配達リード区分\nながの'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceNI" [binding]="'thisTimeSupplyPriceNI'"
            [header]="'供給価格\nにいがた'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceNI">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceNI"
            [binding]="'thisTimeCostPriceNI'" [header]="'仕入価格\nにいがた'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceNI">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumNI" [binding]="'approvedNumNI'"
            [header]="'セット企画数量\nにいがた'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumNI">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceNI" [binding]="'approvedPriceNI'"
            [header]="'成立価格\nにいがた'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceNI">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeNI"
            [binding]="'deliveryLeadTimeTypeNameNI'" [header]="'配達リード区分\nにいがた'" [multiLine]="true">
          </wj-flex-grid-column>

          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceKU" [binding]="'thisTimeSupplyPriceKU'"
            [header]="'供給価格\nクルコ'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceKU">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceKU"
            [binding]="'thisTimeCostPriceKU'" [header]="'仕入価格\nクルコ'" [multiLine]="true" [isReadOnly]="true"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceKU">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" id="col_ApprovedNumKU" [binding]="'approvedNumKU'"
            [header]="'セット企画数量\nクルコ'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumKU">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceKU" [binding]="'approvedPriceKU'"
            [header]="'成立価格\nクルコ'" [multiLine]="true" [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceKU">
              </app-comma-format>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" editable="false" [width]="100" id="col_DeliveryLeadTimeTypeKU"
            [binding]="'deliveryLeadTimeTypeNameKU'" [header]="'配達リード区分\nクルコ'" [multiLine]="true">
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Select" class="btn-primary" forcedEnabledMode="true"
            (click)="eventSelect_CLICKHandler(null)" [tabindex]="0">選択</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>